import SpeciesHelp from "./SpeciesHelp";

export default SpeciesHelp;
export { SpeciesHelp };
